module.exports = __webpack_public_path__ + "img/logo-text.6e5d84dd.png";